import React from 'react'
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import ProductGrid4 from '../../components/public/pages/home/productGrid4';
import ApiUrl from '../../configTools/apiUrl';


const Collection = () => {
    const {id} = useParams();
    const [products,setProducts] = useState([]);
    const [collection,setCollection] = useState({
        id :id,
        title:"",
        slug:"",
        discription:"",
        parentid:0,
        parent:""
    });
    useEffect(() => {
      fetch(ApiUrl.API_URL_ListingCollection+"/"+id)
      .then(res=>res.json())
      .then(data =>{
          if(data.success)
          setProducts(data.responce);
      });
      fetch(ApiUrl.API_URL_Collection+"/"+id)
      .then(res=>res.json())
      .then(data =>{
          setCollection(data);
      });
    },[id])
  return (
    <div>
        <div style={{ margin:"0px 40px"}}>
            <div className='collection_heading'>
                <h3>{collection.title}</h3>
                <p>{collection.discription}</p>
            </div>
            <ProductGrid4 Products={products} Columns={5}/>
        </div>
    </div>
  )
}

export default Collection
